export default {"src":"/_next/static/media/gift-box.ee999f5c.svg","height":512,"width":512};